/**
 * Search Bar Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/search-bar.liquid
 * 
 */

import Vue from 'vue';
import axios from 'axios';
import debounce from 'lodash-es/debounce';
import { mixin as clickaway } from 'vue-clickaway'

Vue.component('search-bar', {
    mixins: [clickaway],
    props: [
        'defaultValue'
    ],

    data() {
        return {
            isSearchLoading: false,
            isSearchOpen: false,
            search: null,
            results: []
        }
    },

    watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
        search(newValue, oldValue) {
            if (newValue) {
                this.isSearchOpen = true;
                this.debouncedPerformSearch();
            } else if (oldValue) {
                this.closeSearch();
                this.results = [];
            }
        }
    },

    created() {
        this.search = this.defaultValue;
        this.debouncedPerformSearch = debounce(this.performSearch, 500);
        

        setTimeout(() => { // Don't show on load on search page
            this.isSearchOpen = false;
        }, 100);
    },

    methods: {
        closeSearch() {
            if(this.isSearchOpen){
                this.isSearchOpen = false;
                this.search = ''
                this.productResult = []
                 this.$emit('close-menu');

                 this.$nextTick(() => {
                    this.$refs['search-field'].blur()
                  })
            }
        },

        handleSearchIconClicked(e) {
            this.isSearchOpen = true;
            this.$emit('close-menu');
            e.preventDefault();
            this.$nextTick(() => {
                this.$refs['search-field'].focus()
            })
        
        },

        performSearch() {
            if (this.search.length) {
                this.isSearchLoading = true;

                axios.get(`/search/suggest.json?s=${this.search}&resources[type]=product&resources[limit]=6`).then((response) => {
                    this.results = response.data.resources.results.products; 
                   
                    if (this.results.length) {
                        setTimeout(() => {
                            let element = document.querySelector('[dropdown-form-wrapper] input');
                            if (element) element.focus();
                        }, 100);

                    }
    
                }).catch((error) => {
                    console.log(error);
    
                }).finally(() => {
                    this.isSearchLoading = false;
                });
            }
        }
    }
});